import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Row from '@sdk/components/ui/spacing/Row';
import Text16 from '@sdk/components/ui/typography/Text16';
import PickerField from '@sdk/components/forms/PickerField';
import type { CurrencyType } from '@sdk/common/currency/types/CurrencyType';
import useConfig from '@sdk/config/useConfig';

import CreditCardForm from '@web/account/purchase/CreditCardForm/CreditCardForm';
import { BillingAddressForm } from '@web/account/billing/BillingAddressForm/BillingAddressForm';

import { usePaymentCycleAndMethod } from './paymentCycleAndMethod.hooks';

export type Props = {
  currency: CurrencyType;
  monthlyPricePerUserPerMonth: number;
  yearlyPricePerUserPerMonth: number;
  yearlyPlanDiscount: number;
  subscriptionBillingCycle: string;
  setSubscriptionBillingCycle: (cycle: string) => void;
  areYearlySubscriptionsEnabled: boolean;
};

const PaymentCycleAndMethod = (props: Props) => {
  const { subscriptionBillingCycle, setSubscriptionBillingCycle, areYearlySubscriptionsEnabled } =
    props;
  const { billingAddressProps, subscriptionCycles, onAddressChange } =
    usePaymentCycleAndMethod(props);
  const { FEATURE_FLAGS } = useConfig();

  return (
    <>
      {areYearlySubscriptionsEnabled ? (
        <>
          <Row>
            <Text16 semiBold themeColor={ThemeColorType.primaryText}>
              {gettext('Billing cycle')}
            </Text16>
          </Row>
          <Row mTop={10} mBottom={30}>
            <PickerField
              options={subscriptionCycles}
              value={subscriptionBillingCycle}
              onChange={setSubscriptionBillingCycle}
            />
          </Row>
        </>
      ) : null}
      <Row>
        <Text16 semiBold themeColor={ThemeColorType.primaryText}>
          {gettext('Payment method')}
        </Text16>
      </Row>

      <CreditCardForm />

      {FEATURE_FLAGS.TAX_CALCULATIONS_ENABLED && (
        <Row mTop={20}>
          <Text16 semiBold themeColor={ThemeColorType.primaryText}>
            {gettext('Billing information')}
          </Text16>
        </Row>
      )}

      <BillingAddressForm onChange={onAddressChange} addressProps={billingAddressProps} />
    </>
  );
};

export default PaymentCycleAndMethod;
